import { Nullable } from '@rbi-ctg/frontend';
import { IRestaurant } from '@rbi-ctg/store';
import { ServiceMode } from 'state/service-mode/types';
import { IPreloadedStoreState } from 'state/store/hooks';

/**
 * Helper function to initialize store for store selection 1.0
 *
 * @param {IPreloadedStoreState} preloaded Preloaded store
 * @param {Nullable<ServiceMode>} serviceMode Selected service mode
 */
export const initStore = (
  preloaded: IPreloadedStoreState,
  serviceMode: Nullable<ServiceMode>
): IRestaurant | null => (!!preloaded.store && serviceMode ? preloaded.store : null);
